import React from 'react';
import SERVER_URL from '../Global';
import { Image } from './../util/Image';
import { Link } from 'react-router-dom';
import { Button, Input, Form, Icon } from 'antd';
import queryString from 'query-string';

export class RestoreUsers extends React.Component {
    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);

        this.state = {
            token: encodeURIComponent(params.passwordToken),
            firstPassword: '',
            secondPassword: '',
            errorChange: false
        };

        this.handleFirstPassword = this.handleFirstPassword.bind(this);
        this.handleSecondPassword = this.handleSecondPassword.bind(this);
        this.restorePassword = this.restorePassword.bind(this);
        document.title = "Polar - Reset Password"
    }

    handleFirstPassword(event) {
        this.setState({ firstPassword: event.target.value });
    }

    handleSecondPassword(event) {
        this.setState({ secondPassword: event.target.value });
    }

    restorePassword(e) {
        e.preventDefault();
        fetch(
            `${SERVER_URL + "api/users/changepassword"}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
                body: JSON.stringify({
                    'newPassword1': this.state.firstPassword,
                    'newPassword2': this.state.secondPassword,
                    'passwordToken': this.state.token
            })
        }).then(response => response.json())
            .then(res => {
            if (res.ok) {
                window.location = "/"
            } else {
                this.setState({ errorChange: true })
            }
        })
    }
    
    render() {
        let passwordNotSame = this.state.firstPassword != this.state.secondPassword && this.state.secondPassword != '' ? <p style={{ color: "red"}}>The two passwords are not the same</p> : ''

        return (
            <Form onSubmit={this.restorePassword} style={{ minWidth: '410px' }} className="login-form">

                <Image src={require('../logo_polar.png')} class="logoLogin" />

                <h4 className="polarBlue" style={{ marginTop:'20px' }}>Change password</h4>

                <Form.Item>
                    <Input.Password
                        autoComplete="new-password"
                        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        placeholder="New password"
                        onChange={this.handleFirstPassword}
                    />
                </Form.Item>

                <Form.Item>
                    <Input.Password
                        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                        autoComplete="new-password"
                        placeholder="Confirm password"
                        onChange={this.handleSecondPassword}
                    />
                </Form.Item>

                {passwordNotSame}

                <Form.Item>

                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Change Password and log in
                    </Button>

                </Form.Item>

                <div style={{ display: 'flex' }}>
                    <span onClick={this.goToCredits} className="fakeLink polarBlue">Credits</span>
                    <div style={{ display: 'block', width: '100%' }}>
                        <Link tag="reputation manager" style={{ display: 'block', width: '100%', textAlign: 'right' }} target="_blank" to="https://www.reputation-manager.it/" ><span className="fakeLink polarBlue">powered by Reputation Manager</span></Link>
                    </div>
                </div>

            </Form>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Users/RestoreUsers.js